export enum HeaderTabs {
    Colors = 'colors',
    Trims = 'trims',
    Packages = 'packages',
    Options = 'options',
    Details = 'details',
}

export type VariantConfiguratorDetailsPageProps = {
    activeTab: HeaderTabs;
    replaceTab: (newTab: HeaderTabs) => void;
    disabled?: boolean;
};
